import { Location } from '@angular/common';
import { animate, Component, Injector, OnInit, state, style, transition, trigger } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date';
import { ToastsManager } from 'ng2-toastr';
import { Observable, Subject } from 'rxjs';
import { IPagedResults } from '../../../core/interfaces';
import { IncidentService } from '../../../services/incident.service';
@Component({
    selector: 'app-daily-report-list',
    templateUrl: './daily-report-list.component.html',
    styleUrls: ['../../layout/layout.component.scss', '../../layout/mobile.css'],
    animations: [
        trigger('slideIn', [
            state('*', style({ 'overflow-y': 'hidden', 'overflow-x': 'hidden' })),
            state('void', style({ 'overflow-y': 'hidden', 'overflow-x': 'hidden' })),
            transition('* => void', [
                style({ height: '*' }),
                animate(300, style({ height: 0 }))
            ]),
            transition('void => *', [
                style({ height: '0' }),
                animate(300, style({ height: '*' }))
            ])
        ])
    ]
})
export class DailyReportListComponent implements OnInit {
    packageData: Subject<any> = new Subject<any[]>();
    public showSpinner: boolean = false;
    public itemPerPage: number = 100;
    public currentPage: number = 1;
    public totalItems: number = 10;
    public isAdminOrUserEditor = false;
    public isSuperAdmin = false;
    public isPreviewOn: boolean = false;
    public parentComponent: any;
    public selectedDate: NgbDateStruct;
    public selectedIncidentEndDate: NgbDateStruct;
    public accountId: number = 0;
    public withData: boolean = false;
    public searchChangeObserver;
    public lastSearchedKeyword: any;
    public searchKeyword: any;
    IncidentDate: NgbDateStruct;
    IncidenEndtDate: NgbDateStruct;
    SiteId: number;
    public type1Filter: number;
    public type2Filter: number;
    public type3Filter: number;
    searchText: string = "";

    constructor(private parentInj: Injector,
        private router: Router,
        private location: Location,
        private route: ActivatedRoute,
        private toastr: ToastsManager,
        private incidentService: IncidentService) { }

    ngOnInit() {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'))
        this.accountId = currentUser.accountId;
        this.SiteId = +localStorage.getItem('currentSiteId');

        var date = new Date();
        this.selectedDate = new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate());

        this.IncidentDate = { day: date.getUTCDate(), month: date.getUTCMonth(), year: date.getUTCFullYear() };
        this.IncidentDate.day = this.selectedDate.day;
        this.IncidentDate.month = this.selectedDate.month;
        this.IncidentDate.year = this.selectedDate.year;

        this.selectedIncidentEndDate = { day: date.getUTCDate(), month: date.getUTCMonth() + 1, year: date.getUTCFullYear() };

        if (!this.IncidenEndtDate) {
            this.IncidenEndtDate = this.selectedIncidentEndDate;
        }

        this.IncidenEndtDate.day = this.selectedIncidentEndDate.day;
        this.IncidenEndtDate.month = this.selectedIncidentEndDate.month;
        this.IncidenEndtDate.year = this.selectedIncidentEndDate.year;

        this.loadDataById(this.accountId, this.searchText);
        // this.selectedDate.month = date.getMonth() -1;
        // this.selectedDate.day = date.getDate();
        // this.selectedDate.year = date.getFullYear();
        // let lastKeyword = this.loanService.getLastSearchedKeyword();
        // if(lastKeyword)
        // {
        //     this.searchKeyword = lastKeyword;
        //     this.onSearchChange(this.searchKeyword);
        // }
    }

    public reload() {
        this.selectedDate.day = this.IncidentDate.day;
        this.selectedDate.month = this.IncidentDate.month;
        this.selectedDate.year = this.IncidentDate.year;

        this.selectedIncidentEndDate.day = this.IncidenEndtDate.day;
        this.selectedIncidentEndDate.month = this.IncidenEndtDate.month;
        this.selectedIncidentEndDate.year = this.IncidenEndtDate.year;


        this.loadDataById(this.accountId, this.searchText);
    }

    public loadDataById(id: number, keyword: string = "") {
        this.showSpinner = true;
        var date = this.selectedDate.year + '-' + this.selectedDate.month + '-' + this.selectedDate.day;
        this.incidentService.getAllIncidents(this.accountId, this.SiteId, date, date, 0, 0, 0, "")
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: IPagedResults<any>) => {
                this.packageData.next(response.Data);
                this.totalItems = response.Data.length;
                this.withData = response.Data.length > 0;
                // if(response.Data.length === 1)
                // {
                //     this.navigateDetails(response.Data[0].Id);   
                // }
            });
    }

    public navigateDetails(id?: number) {
        this.router.navigate([`incidents/${id}/edit`]);
        // this.router.navigate([`mobile/daily-report/${id}/preview`]);
    }

    public onSearchChange(searchValue: string) {

        this.showSpinner = true;
        if (!this.searchChangeObserver) {
            Observable.create(observer => {
                this.searchChangeObserver = observer;
            }).debounceTime(500)
                .distinctUntilChanged()
                .subscribe((term) => {
                    this.searchText = term;
                    let keyword = this.searchText;
                    //this.loanService.setLastSearchedKeyword(keyword);
                    //  
                    this.loadDataById(this.accountId, keyword);
                });
        }

        this.searchChangeObserver.next(searchValue);
    }

    public navigateToLanding() {
        // this.location.back();
        this.router.navigate(['/mobile'], { relativeTo: this.route })
    }

}



// WEBPACK FOOTER //
// ./src/app/components/mobile/daily-report/daily-report-list.component.ts